module.exports = __webpack_public_path__ + "img/trading3.6dab9964.svg";